// extracted by mini-css-extract-plugin
module.exports = {"rtbBanner_mobile":"FooterBanner_rtbBanner_mobile__4OC92","rtbBanner_desktop":"FooterBanner_rtbBanner_desktop__MTpQ6"};